



import React, { useEffect, useRef, useState } from "react";
import { PDFDocument } from "pdf-lib";
import mammoth from "mammoth";
import LoadingSpinner from "../helpers/loadingspinner";
import stringSimilarity from "string-similarity";
import Swal from "sweetalert2";
import * as pdfjsLib from "pdfjs-dist";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { AddBenchCandidatesProfile_BulkImportwithDocs, GenerateContent, GetJobPosts } from "../apiconstants/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { useCountry } from "../contexts/countrycodecontext.js";
import Select from 'react-select';
import { useForm ,Controller} from "react-hook-form";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const ResumeParserwithAi = () => {
     const { formState,control,setValue,register,getValues} = useForm({
  });
      const { errors } = formState
const stripHtmlTags = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

  const token = localStorage.getItem('jwtToken');
  const [resumeText, setResumeText] = useState([]);
  const [text,setText] = useState("")
  const [jobResponsibilities, setJobResponsibilities] = useState("");
  const [matchPercentage, setMatchPercentage] = useState(null);
   const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [matchReason, setMatchReason] = useState(null);
  const [extractedCertifications, setExtractedCertifications] = useState(null);
    const [candidateType,setCandidateType] = useState([
        {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
        {candidateTypeID:"C2C",typeName:"C2C"},
        {candidateTypeID:"W2",typeName:"W2"},
      {candidateTypeID:"1099",typeName:"1099"}]);
  const [extractedDetails, setExtractedDetails] = useState({
    name: "",
    email: "",
    phone: "",
    certifications: [],
  });
  const [extractedSkills, setExtractedSkills] = useState([]);
  const [extractedTextSkills, setExtractedTextSkills] = useState([]);
  const [previousJobResponsibilities, setPreviousJobResponsibilities] = useState("");  
  const [previousResult, setPreviousResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [jobPosts, setJobPosts] = useState([]);
      const { selectedCountry} = useCountry();
const [jobRoleOptions, setJobRoleOptions] = useState([]);
const [jobRoleDescriptions, setJobRoleDescriptions] = useState({});
const [isGapAnalysisChecked, setIsGapAnalysisChecked] = useState(false);
const [isNeedAdditionalPointsChecked, setIsNeedAdditionalPointsChecked] = useState(false);
const [isComparing, setIsComparing] = useState(false);
const [isGenerateQuestionsChecked, setIsGenerateQuestionsChecked] = useState(false);
const [screeningQuestions, setScreeningQuestions] = useState([]);
const [uploadedFiles, setUploadedFiles] = useState([]);
const [selectedCandidates, setSelectedCandidates] = useState([]);
const [selectedJobPostId, setSelectedJobPostId] = useState(null);

  useEffect(()=>{
    fetchJobPosts();
    if(resumeText  && jobResponsibilities) {
      setShowDetails(false);
    }
  },[selectedCountry])

useEffect(() => {
  if (isGapAnalysisChecked) {
    handleGapAnalysis();
  }
  if (isNeedAdditionalPointsChecked) {
    handleNecessaryPoints();
  }
}, [isGapAnalysisChecked, isNeedAdditionalPointsChecked]);



  let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const roleID = localStorage.getItem("roleID")
    const email = localStorage.getItem("email")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
const generateInsightsPdfBlob = async () => {
  const element = printRef.current;
 
  // 🔽 Reduce scale (was 1.5)
  const canvas = await html2canvas(element, {
    scale: 1,           // ✅ Key reduction
    useCORS: true,
    backgroundColor: "#ffffff"
  });
 
  // 🔽 Use JPEG instead of PNG (huge size win)
  const imgData = canvas.toDataURL("image/jpeg", 0.6); // quality 60%
 
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
 
  const marginX = 10;
  const marginY = 10;
 
  const imgWidth = pageWidth - marginX * 2;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
 
  let heightLeft = imgHeight;
  let position = marginY;
 
  // First page
  pdf.addImage(imgData, "JPEG", marginX, position, imgWidth, imgHeight);
  heightLeft -= pageHeight - marginY * 2;
 
  // Extra pages
  while (heightLeft > 0) {
    position = heightLeft - imgHeight + marginY;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", marginX, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - marginY * 2;
  }
 
  // ✅ Blob output
  return pdf.output("blob");
};
 

      const handleSaveCandidates = async () => {
       setIsLoading(true);
       const filteredResumes = resumeText.filter((item) =>
  selectedCandidates.includes(item.email)
);

if (filteredResumes.length === 0) {
  Swal.fire({
    icon: "warning",
    title: "No candidates selected",
    text: "Please select at least one candidate before saving.",
  });
  setIsLoading(false);
  return;
}
const candidateTypeSelected = getValues("CandidateType");
if (candidateTypeSelected === undefined || candidateTypeSelected === "") {
  Swal.fire({
    icon: "warning",
    title: "Candidate Type not selected",
    text: "Please select Candidate Type before saving.",
  });
  setIsLoading(false);
  return;
}
const formattedData = filteredResumes?.map((item) => {
  const obj = {
    userGuid: Guid,
    fullName: item?.name,
    email: item?.email,
    mobileNumber: item.phoneNumber?.toString(),
    dob: null,
    gender: "Male",
    address: item.address,
    jobRole: '5',
    maritalStatus: "married",
    technicalSkill: item.skills?.join(", "),
    experience: item.experience,
    preferLocation: item.Country,
    workMode: "Hybrid",
    profileSummery: item.overallSummary,
    billRate: item.billRate,
    payRate: item.payRate,
    workAuthorizationandValidity: item.workAuthorizationandValidity,
    employerName: item.employerName,
    ssn: item.ssn?.toString(),
    passportNo: item.passportNo,
    tworefrencesfromrecentproject: item.tworefrencesfromrecentproject,
    linkedInUrl: item.linkedin,
    certifications: item.certifications?.join(", "),
    createdBy: email,
    countryID: selectedCountry,

    // ✅ ADD THIS
    candidateType: candidateTypeSelected,

    jobPostID: selectedJobPostId
  };

  if (!selectedJobPostId) delete obj.jobPostID;
  return obj;
});


           console.log("138📝 Formatted Candidate Data:", formattedData); 
       const formDataToSend = new FormData();
    formDataToSend.append("CandidatesJson", JSON.stringify(formattedData)); // JSON data
    console.log("324",uploadedFiles)
    uploadedFiles.forEach((file) => {
      formDataToSend.append("ResumeFiles", file, file.name); // ✅ Add each file
    });
    // ✅ Generate and attach the Resume Insights PDF as binary
  const pdfBlob = await generateInsightsPdfBlob();
  formDataToSend.append("Resume_Insights_Pdf", pdfBlob, "Resume_Insights.pdf");
        try {
          const response = await axios.post(
            AddBenchCandidatesProfile_BulkImportwithDocs.APIURL,
            formDataToSend,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
      
      
      if (response.data.candidates && Array.isArray(response.data.candidates)) {
        const messages = response.data.candidates?.map((candidate) => {
          const { email, statusMessage } = candidate;
     if (email === "N/A") {
          return `❌ <strong>Email doesn’t exist</strong> for that candidate.`;
        } 
          else if (statusMessage === 'Inserted') {
            return `✅ <strong>${email}</strong> added successfully.`;
          } else if (statusMessage === 'Duplicate or Already Exists') {
            return `⚠️ <strong>${email}</strong> already exists.`;
          } else {
            return `ℹ️ <strong>${email}</strong>: ${statusMessage}`;
          }
        });
        setIsLoading(false);
        Swal.fire({
          icon: 'info',
          title: 'Candidate Upload Summary',
          html: messages.join('<br>'),
          showConfirmButton: true,
        });
      } else {
     setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Unexpected response format.',
          text: 'Please check the server response.',
          showConfirmButton: true,
        });
      }
    
    
    
        } catch (error) {
       setIsLoading(false);
          console.error("Error saving candidates:", error);
        }
      };

const fetchJobPosts = async () => {
  try {
    const response = await axios.get(`${GetJobPosts.APIURL}?Userguid=${Guid}&CountryID=${selectedCountry}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const posts = response.data;

    // Filter only job posts that are active by both status and isActive flag
    const activePosts = posts.filter(post => post.status == "Active" );

    // Create a map to count occurrences of titles
    const titleCount = {};
    activePosts.forEach(post => {
      titleCount[post.title] = (titleCount[post.title] || 0) + 1;
    });

    const options = activePosts.map(post => {
      const isDuplicate = titleCount[post.title] > 1;
      const label = `${post.title} (${post.clientName})`; // You can append more info if needed

      return {
        label,
        value: post.jobPostID,
      };
    });

    const descriptionMap = {};
    activePosts.forEach(post => {
      descriptionMap[post.jobPostID] = post.jobDescription || "";
    });

    setJobRoleOptions(options);
    setJobRoleDescriptions(descriptionMap);
    setIsLoading(false);
  } catch (error) {
    console.error("Error fetching job posts", error);
    setIsLoading(false);
  }
};


   const handleFileUpload = async (event) => {  
       const files = Array.from(event.target.files);
         setUploadedFiles(files);
     if (!files || files.length === 0) {
       setResumeText([]);
       return;
     }
     setIsGapAnalysisChecked(false);
     setIsNeedAdditionalPointsChecked(false);
     setIsGenerateQuestionsChecked(false);
     setIsComparing(true);
     setPreviousResult(null);
     setScreeningQuestions([]);
     setShowDetails(false);
     setLoading(true);
     const allowedFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
     
     let extractedResumes = []; 
 
     for (const file of files) {
         if (!allowedFormats.includes(file.type)) {
             Swal.fire({
                 position: 'center',
                 icon: 'warning',
                 title: 'Please upload only .pdf or .docx files',
                 showConfirmButton: false,
                 timer: 3000
             });
             continue; 
         }
 
         try {
             let extractedText = await extractTextFromFile(file);
             console.log(`Extracted Resume Text for ${file.name}:`, extractedText);
             const extractedDetails = await extractDetails(extractedText);
               extractedResumes.push({ fileName: file.name,
               resumeText: extractedText, ...extractedDetails });
         } catch (err) {
             setIsComparing(false);
             console.error(`Error extracting text from ${file.name}:`, err);
         }
     }
 
     console.log("Extracted Resumes:", extractedResumes);
     setLoading(false)
     setIsComparing(false);
     setResumeText(extractedResumes); 
 };
 
 console.log("resumeText",resumeText.resumeText)
 
 const extractDetails = async (text) => {
   console.log("80",text)
   try {
    const response = await axios.post(
   GenerateContent.APIURL,
   {
    prompt: `Extract all certifications mentioned in this resume text. 
      Return only a comma-separated list of certifications without extra text:\n\n${text}`,
},
{ headers: {
  'Content-Type': 'application/json',
  'accept': '*/*',
  'Authorization': `Bearer ${token}` // Add the Authorization header       
   }}
    );

    console.log("API Response:", response);

    const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
    const certMatches = responseContent?.split(",").map((cert) => cert.trim());
         
         const extractedSkills = await analyzeSkill(text);
         console.log("extractedSkills",extractedSkills)
 
         return {
             skills: extractedSkills.length > 0 ? extractedSkills : ["Not Found"],
             certifications: certMatches?.length > 0 ? certMatches : ["Not Found"],
         };
     } catch (err) {
          if (err.response && err.response.status === 401) {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Session expired! Please Login again',
                showConfirmButton: false,
                timer: 5000,
              }); 
              setTimeout(() => {
                window.location.href = "/Login"; // Redirect to login page
              }, 5000);
              return;
            }
         console.error("Error extracting certifications:", err);
         return {
             skills: extractedSkills.length > 0 ? extractedSkills : ["Not Found"],
             certifications: ["Not Found"],
         };
     }
 };

  const extractTextFromFile = async (file) => {
    if (file.type === "application/pdf") {
      return extractTextFromPDF(file);
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      return extractTextFromDOCX(file);
    } else {
      throw new Error("Unsupported file type. Please upload a PDF or DOCX.");
    }
  };

  const extractTextFromPDF = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let extractedText = "";

    for (let i = 0; i < pdf.numPages; i++) {
        const page = await pdf.getPage(i + 1);
        const textContent = await page.getTextContent();
        extractedText += textContent.items.map(item => item.str).join(" ") + " ";
    }

    const isValidResume = /experience|projects|skills|summary|education/i.test(extractedText);
if (!isValidResume) {
  extractedText = "[INVALID DOCUMENT] " + extractedText;
}

    return extractedText;
};

  // const extractTextFromDOCX = async (file) => {
  //   const reader = new FileReader();
  //   return new Promise((resolve, reject) => {
  //     reader.onload = async (event) => {
  //       const arrayBuffer = event.target.result;
  //       mammoth
  //         .extractRawText({ arrayBuffer })
  //         .then((result) => resolve(result.value))
  //         .catch((err) => reject(err));
  //     };
  //     reader.readAsArrayBuffer(file);
  //   });
  // };


const extractTextFromDOCX = async (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = async (event) => {
      const arrayBuffer = event.target.result;
      try {
        const result = await mammoth.extractRawText({ arrayBuffer });
        let extractedText = result.value;

        // ✅ Resume validation check using common keywords
        const isValidResume = /experience|skills|projects|education|summary/i.test(extractedText);

        if (!isValidResume) {
          extractedText = "[INVALID DOCUMENT] " + extractedText;
        }

        resolve(extractedText);
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

  const handleDetails = ()=>{
    setShowDetails(true)
  }

 
  const analyzeResumesAndCertifications = async () => {
    setIsLoading(true);
    if (!resumeText || resumeText.length === 0 || !jobResponsibilities ) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload at least one resume and job responsibilities.',
        showConfirmButton: false,
        timer: 3000
    });
      setIsLoading(false);
      setShowDetails(false);
      setResumeText([])
      return;
    }
      try {
      const jobskillsResults = await analyzetextareaSkill();
      console.log("201",jobskillsResults)
      const results = await updateMatchedSkills(jobskillsResults);
      const resumeResults = await analyzeResume();
      console.log("202",resumeResults)
        // const certificationResults = await analyzeCertifications();
if (isGenerateQuestionsChecked) {
  const questions = await generateScreeningQuestions(jobResponsibilities);
  setScreeningQuestions(questions);  // now questions is { screening_questions: [...], coding_questions: [...] }
}

console.log("Generated Screening Questions:", screeningQuestions);


           // Optional Gemini API calls
       setResumeText((prev) =>
        prev.map((resume, index) => ({
          ...resume,
          ...results,
          fitMatchScore: resumeResults[index]?.fitMatchScore || "0",
          jobTitleMatchScore: resumeResults[index]?.jobTitleMatchScore || "0",
          experienceMatchScore: resumeResults[index]?.experienceMatchScore || "0",
          necessaryImprovements: resumeResults[index]?.necessaryImprovements || ["No improvements provided."],
          overallSummary:resumeResults[index]?.overallSummary || "Not Provided",
          overallFitTable: resumeResults[index]?.overallFitTable || [],
          skillGaps: resumeResults[index]?.skillGaps || [],
          matchedSkillsInRecentProjects:resumeResults[index]?.matchedSkillsInRecentProjects || []
  // matchedCertificationswithJobResponsibilities:
          //   certificationResults[index]?.matchedCertifications || ["No matched certifications found"],
        }))
        
      );
   
    } catch (error) {
      console.error("Error analyzing resumes and certifications:", error);
    }finally {
      setIsLoading(false);
    }
  };
console.log("Checkbox checked?", isGenerateQuestionsChecked);

const generateScreeningQuestions = async (jobDescription) => {
  try {
    const response = await axios.post(
      GenerateContent.APIURL,
      {
  prompt: `You are a professional recruiter assistant.

From the Job Description below, generate exactly:
1. **5 short and direct screening questions** with sample strong answers
2. **5 simple coding questions** with solutions

---

✅ Rules for Screening Questions:
- Be exactly **one line**
- Be specific and skill-focused
- Each question must come directly from the tools, technologies, or responsibilities in the Job Description (e.g., AWS, CI/CD, Docker, Terraform, monitoring)
- Provide a **sample strong answer**

✅ Rules for Coding Questions:
- Must be **easy to intermediate**
- Each question must test a skill, tool, or technology explicitly mentioned in the Job Description
- Be short and specific (1–2 lines max)
- Provide a **clear solution or output**
- Avoid generic/unrelated questions (e.g., Hello World, SQL unless DBs are in the JD)

---

### Output Format (strict JSON only):
{
  "screening_questions": [
    { "question": "What is your experience with ...?", "answer": "Sample strong answer..." }
  ],
  "coding_questions": [
    { "question": "Write a Terraform configuration to create an AWS S3 bucket.", "answer": "resource \\"aws_s3_bucket\\" \\"example\\" { bucket = \\"my-bucket\\" }" }
  ]
}

---

### Job Description:
${jobDescription}
`
},

      {
        headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    const rawText = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
    const cleaned = rawText.replace(/```json\s*|```/g, "").trim();
    console.log("aaaaaaaaaaaa", JSON.parse(cleaned));
    return JSON.parse(cleaned);
  } catch (error) {
    console.error("Error generating screening & coding questions:", error);
    return { screening_questions: [], coding_questions: [] };
  }
};

 const analyzeResume = async () => {
    if (!resumeText || resumeText.length === 0 || !jobResponsibilities) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload at least one resume and job description.',
        showConfirmButton: false,
        timer: 3000
      });
      return null;
    }
  
    try {
      // Create an array of promises to process each resume in parallel
    const requests = resumeText.map(async (resume, index) => {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
      prompt :`You are a professional AI Resume Evaluator.

Your task is to analyze the resume and job description below and return an overall fit score and structured evaluation based **only on the requirements clearly present in the Job Description**.

Avoid guessing or scoring on criteria that are not explicitly stated in the JD (e.g., do not assume domain, system design, or seniority level unless clearly mentioned).

---

### Evaluation Focus:
- Match of **years of experience** (if specified)
- Match of **technical skills and tools** (e.g., React, APIs, AWS, etc.)
- Alignment with the **job duties and responsibilities**
- **Communication or collaboration** skills only if explicitly stated in the JD
- Evaluate **depth and recency** of each skill (actively used vs. just listed)

---

### Scoring Method:
- Start with a base score of 0.
- Add points based on the degree of match in each category below.
- Use the following **weighted distribution**:

YearsOfExperience: 25 points  
TechnicalSkills: 40 points  
JobDutiesAlignment: 25 points  
Communication/Collaboration: 10 points

- Award:
  - ✅ Full credit for clearly demonstrated matches (with project use or active involvement)
  - 🔶 Partial credit for mentioned but unsupported or indirectly relevant skills
  - ❌ No credit for skills not found
- Normalize the final score to a 100-point scale.

---

2. **experienceMatchScore (0–100):**
   - Focus only on how well the candidate’s total and relevant years of experience match the JD requirements.
   - Give higher points if years and domain align well.
   - Deduct points for gaps, irrelevant domains, or significantly less experience.

3. **jobTitleMatchScore (0–100):**
   - Compare the candidate’s  **current and previous**  job titles to the JD title.
   - Award higher points for close or similar roles (e.g., “Frontend Developer” ≈ “React Developer”).
   - Penalize for unrelated or junior titles.

### Output Format (strict JSON only):

{
  "fitMatchScore": 0,
  "experienceMatchScore": 0,
  "jobTitleMatchScore": 0,
  "scoreBreakdown": {
    "YearsOfExperience": 0,
    "TechnicalSkills": 0,
    "JobDutiesAlignment": 0,
    "Communication/Collaboration": 0
  },
  "improvementInsights": [
    "Mention more relevant skills found in the JD such as XYZ.",
    "Include specific examples of past projects using ABC."
  ],
  "overallSummary": "3–5 lines summarizing how well the resume matches the job, and any key gaps.",
  "skillGaps": [
    {
      "JD Skill": "ReactJS",
      "Found in Resume": "Used in multiple client projects (2022–2024)",
      "Match": "✅"
    },
    {
      "JD Skill": "AWS",
      "Found in Resume": "Mentioned under cloud experience, no project usage shown",
      "Match": "🔶"
    },
    {
      "JD Skill": "GraphQL",
      "Found in Resume": "No",
      "Match": "❌"
    }
  ],
   "matchedSkillsInRecentProjects": [
  {
    "JD Skill": "ReactJS",
    "Found in Project": "Used ReactJS in UI development (2023–2024)"
  },
  {
    "JD Skill": "Node.js",
    "Found in Project": "Job Portal Backend — REST API built with Node.js"
   }
 ],
  "inconsistencyCheck": "Optional: Add if years of experience or skill claims are not supported by project examples or timeline."
}

---
In addition to the fields above, you must also extract:

- A new field called **matchedSkillsInRecentProjects**
- It must list only those JD skills that were clearly used in the **most recent 2–3 projects** mentioned in the resume
- For each matched skill, include the **JD Skill name** and where it was found (e.g., project title or description)
- Format it exactly as shown above in the JSON response
### Resume:
${resume.resumeText}

### Job Description:
${jobResponsibilities}
`


    },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
    );
    console.log(`📄 Response for Resume ${index + 1}:`, response);

    const rawText = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
    const cleaned = rawText.replace(/```json\s*|```/g, "").trim();
  
        try {
          const parsed = JSON.parse(cleaned);
          console.log("379",parsed)
          // return { resumeIndex: index + 1, reasons: parsed };
       return {
  resumeIndex: index + 1,
 fitMatchScore: resume.resumeText.startsWith("[INVALID DOCUMENT]") ? 0 : parsed.fitMatchScore || 0,
   experienceMatchScore: resume.resumeText.startsWith("[INVALID DOCUMENT]") ? 0 : parsed.experienceMatchScore || 0,
  jobTitleMatchScore:resume.resumeText.startsWith("[INVALID DOCUMENT]") ? 0 :  parsed.jobTitleMatchScore || 0,
  necessaryImprovements: parsed.improvementInsights || [],
  overallSummary: parsed.overallSummary || "Not available",
  overallFitTable: parsed.overallFitTable || [],
  skillGaps: Array.isArray(parsed.skillGaps) ? parsed.skillGaps : [{ "JD Skill": "N/A", "Found in Resume": "N/A", "Match": "❌" }],
    matchedSkillsInRecentProjects: parsed.matchedSkillsInRecentProjects || []  // ✅ NEW
};

        } catch (err) {
          console.error(`❌ Failed to parse insight response for Resume ${index + 1}:`, rawText);
          return { resumeIndex: index + 1, fitMatchScore: ["Error parsing response."] };
        }
      });
  
      // Execute all API requests in parallel
      const results = await Promise.all(requests);
      console.log("✅ Final Insights for All Resumes:", results);
  
      return results; // ✅ Return structured insights for all resumes
  
    } catch (err) {
          if (err.response && err.response.status === 401) {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Session expired! Please Login again',
                showConfirmButton: false,
                timer: 5000,
              }); 
              setTimeout(() => {
                window.location.href = "/Login"; // Redirect to login page
              }, 5000);
              return;
            }
      console.error("❌ Error analyzing resumes:", err);
      return null;
    }
  };
const handleGapAnalysis = async () => {
  if (!resumeText || resumeText.length === 0) {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please upload at least one resume.',
      showConfirmButton: false,
      timer: 3000
    });
    return null;
  }
setIsComparing(true);
  try {
    const requests = resumeText.map(async (resume, index) => {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
          prompt: `You are a professional resume evaluator.

Analyze the following **Resume** and identify any **career time gaps** — unexplained breaks or missing employment periods of 6 months or more in the candidate's career timeline.

### Guidelines:
- Focus only on **time gaps** in employment history.
- Detect if there are **large breaks** (6+ months) between jobs.
- Mention if the resume lacks **recent experience** (e.g., no job listed after 2021).
- Do not analyze technical skills, certifications, or compare with a job description.
- Output must be a valid **JSON array of strings only**.
- Do not include markdown, summaries, or additional explanation.

### Resume:
${resume.resumeText}

### Output Format:
[
  "Gap 1",
  "Gap 2",
  "Gap 3"
]
`
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      const rawText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const cleaned = rawText.replace(/```json\s*|```/g, "").trim();

      try {
        const parsed = JSON.parse(cleaned);
        setIsComparing(false);
        return { index, timeGaps: parsed };
      } catch (err) {
       setIsComparing(false);
        console.error(`❌ Failed to parse time gap response for Resume ${index + 1}:`, rawText);
        return { index, timeGaps: ["Error parsing response."] };
      }
    });

    const results = await Promise.all(requests);

    // ✅ Set in resumeText
    setResumeText((prev) =>
      prev.map((resume, index) => {
        const found = results.find((r) => r.index === index);
        return { ...resume, timeGaps: found?.timeGaps || [] };
      })
    );

    return results;

  } catch (err) {
         setIsComparing(false);
    if (err.response?.status === 401) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Session expired! Please Login again',
        showConfirmButton: false,
        timer: 5000,
      });
      setTimeout(() => {
        window.location.href = "/Login";
      }, 5000);
      return;
    }
    console.error("❌ Error analyzing resumes:", err);
    return null;
  }
};

const handleNecessaryPoints = async () => {
  if (!resumeText || resumeText.length === 0 || !jobResponsibilities) {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please upload at least one resume and job description.',
      showConfirmButton: false,
      timer: 3000
    });
    return null;
  }
        setIsComparing(true);

  try {
    const requests = resumeText.map(async (resume, index) => {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
        prompt: `You are a technical resume writing expert.

Your task is to review the candidate's resume and compare it with the job description. Then, generate exactly **5 resume-ready bullet points** that the candidate should **add** to their resume to match the job description better.

### Important Rules:
- Each bullet point must look like it was written **in a professional resume**.
- These points should reflect **experience with technologies or responsibilities** mentioned in the job description but missing or weak in the resume.
- Include **technical skills**, **tools**, **projects**, **databases**, or **frameworks** — in the form of realistic experience lines.
- Write bullet points even if the resume does not mention those tools — use common industry experience assumptions.
- DO NOT explain, DO NOT summarize — just output 5 bullet points in valid **JSON array format**.

### Resume:
${resume.resumeText}

### Job Description:
${jobResponsibilities}

### Output Format (JSON):
[
  "Resume bullet point 1",
  "Resume bullet point 2",
  "Resume bullet point 3",
  "Resume bullet point 4",
  "Resume bullet point 5"
]
`

        },
        {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      const rawText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const cleaned = rawText.replace(/```json\s*|```/g, "").trim();

      try {
        const parsed = JSON.parse(cleaned);
      
        return { index, enhancements: parsed };
      } catch (err) {
        console.error(`❌ Failed to parse improvement points for Resume ${index + 1}:`, rawText);
        return { index, enhancements: ["Error parsing response."] };
      }
    });

    const results = await Promise.all(requests);
 setIsComparing(false);
    // ✅ Set in resumeText
    setResumeText((prev) =>
      prev.map((resume, index) => {
        const found = results.find((r) => r.index === index);
       return { ...resume, enhancements: found?.enhancements || [] };

      })
    );

    return results;

  } catch (err) {
         setIsComparing(false);
    if (err.response?.status === 401) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Session expired! Please Login again',
        showConfirmButton: false,
        timer: 5000,
      });
      setTimeout(() => {
        window.location.href = "/Login";
      }, 5000);
      return;
    }
    console.error("❌ Error analyzing resumes:", err);
    return null;
  }
};

 
  const analyzeSkill = async (resumeText) => {
    if (!resumeText) {
      setError("Please upload a resume.");
      return;
    }
    try {
      const response = await axios.post(
    GenerateContent.APIURL,
    {
        prompt:`Extract all skills from the following text. Follow these guidelines:

                1. *Extract All Skills:*  
                  - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                  - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                  - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                2. *Hidden and Embedded Skills:*  
                  - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                  - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                3. *Normalization:*  
                  - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                4. *DevOps and Monitoring Tools:*  
                  - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                5. *Format Output:*  
                  - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                  - Remove duplicates and ensure consistent formatting.  

                6. *Retry and Match:*  
                  - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                  - If you suspect that some skills were not captured, retry extraction automatically.  

                7. *Exclude:*  
                  - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                  - Exclude job responsibilities and achievements.  
                  - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                ### Examples of Expected Skills:
                - Programming: Python, Java, C++, SQL  
                - Platforms: AWS, Azure, GCP, Kubernetes  
                - DevOps: Jenkins, Docker, Terraform, Grafana  
                - Data Tools: Spark, Hive, Snowflake, Databricks  
                - Industry Skills: Financial Analysis, Healthcare Compliance 
### Resume:
${resumeText}`,
    },
    { headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
      'Authorization': `Bearer ${token}` // Add the Authorization header       
       }}
);

console.log("API Response:", response);

const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
const extractedSkills = responseContent.split(",").map((skill) => skill.trim());
      setExtractedSkills(extractedSkills);
      return extractedSkills;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          window.location.href = "/Login"; // Redirect to login page
        }, 5000);
        return;
      }
      console.error("Error extracting skills:", err);
      setError("Failed to extract skills.");
    }
  };

  const analyzetextareaSkill = async () => {
    if (!jobResponsibilities) {
      setError("Please enter key skills in the text area.");
      return;
    }
  
    try {
      const response = await axios.post(
      GenerateContent.APIURL,
        {
            prompt: `Extract all skills from the following text. Follow these guidelines:

                    1. *Extract All Skills:*  
                      - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                      - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                      - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                    2. *Hidden and Embedded Skills:*  
                      - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                      - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                    3. *Normalization:*  
                      - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                    4. *DevOps and Monitoring Tools:*  
                      - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                    5. *Format Output:*  
                      - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                      - Remove duplicates and ensure consistent formatting.  

                    6. *Retry and Match:*  
                      - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                      - If you suspect that some skills were not captured, retry extraction automatically.  

                    7. *Exclude:*  
                      - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                      - Exclude job responsibilities and achievements.  
                      - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                    ### Examples of Expected Skills:
                    - Programming: Python, Java, C++, SQL  
                    - Platforms: AWS, Azure, GCP, Kubernetes  
                    - DevOps: Jenkins, Docker, Terraform, Grafana  
                    - Data Tools: Spark, Hive, Snowflake, Databricks  
                    - Industry Skills: Financial Analysis, Healthcare Compliance 
                    
                    text:
                    ${jobResponsibilities}`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
    );

    console.log("API Response:", response);

    const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
    const  extractedTextSkills = (responseContent.split(",").map((skill) => skill.trim()));
    setExtractedTextSkills(extractedTextSkills)
      return extractedTextSkills
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          window.location.href = "/Login"; // Redirect to login page
        }, 5000);
        return;
      }
      console.error("Error extracting skills:", err);
      setError("Failed to extract skills.");
    }
  };


  const analyzeResumeWithJD = async (resumeText, jobResponsibilities) => { 
    if (!resumeText || !jobResponsibilities) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload a resume or job responsibilities.',
        showConfirmButton: false,
        timer: 3000
      });
      return null;
    }
  
    if (jobResponsibilities === previousJobResponsibilities && previousResult !== null) {
      console.log("Using cached result:", previousResult);
      setMatchPercentage(previousResult);
      return previousResult;
    }
  
    try {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
            prompt: `You are an expert resume analysis engine.
  
  Compare the following **Resume** and **Job Description**, and return a JSON object with exactly the following fields only:
  
  1. **name**: Full name extracted from the resume.
  2. **email**: Email address from the resume.
  3. **phoneNumber**: Phone number from the resume.
  4. **matchedSkills**: A list of *technical skills* found in both the resume and the job description.
  5. **unmatchedSkills**: A list of *key technical skills* present in the job description but NOT found anywhere in the resume.
  6. **totalJDskills**: The total number of unique skills extracted from the job description.
  
  ### Resume:
  ${resumeText}
  
  ### Job Description:
  ${jobResponsibilities}
  
  ### Output Format (JSON Only):
  {
    "name": "Full Name",
    "email": "example@email.com",
    "phoneNumber": "1234567890",
    "matchedSkills": ["Skill1", "Skill2"],
    "unmatchedSkills": ["SkillA", "SkillB"],
    "totalJDskills": 10
  }`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
    
    );

    console.log("API Response:", response);

    // Extract response content
    const responseText = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
    console.log("Extracted Text:", responseText);
  
      // Clean up markdown backticks before parsing
      const sanitizeJsonResponse = (text) => {
        return text.replace(/```json\s*|```/g, "").trim();
      };
  
      try {
        const cleanedJson = sanitizeJsonResponse(responseText);
        const parsedJson = JSON.parse(cleanedJson);
  
        // Calculate Matched Skills Percentage
        const matchedSkillsCount = parsedJson.matchedSkills?.length || 0;
        const totalJDskills = parsedJson.totalJDskills || (matchedSkillsCount + (parsedJson.unmatchedSkills?.length || 0));
        const matchedSkillsPercentage = totalJDskills > 0 ? ((matchedSkillsCount / totalJDskills) * 100).toFixed(2) : "0.00";
  
        const result = {
          name: parsedJson.name || "N/A",
          email: parsedJson.email || "N/A",
          phoneNumber: parsedJson.phoneNumber || "N/A",
          matchedSkills: parsedJson.matchedSkills || [],
          unmatchedSkills: parsedJson.unmatchedSkills || [],
          matchedSkillsPercentage: matchedSkillsPercentage
        };
  
        setMatchReason(result);
        setPreviousJobResponsibilities(jobResponsibilities);
        setPreviousResult(result);
        setMatchPercentage(result);
  
        console.log("Processed Result:", result);
        return result; // ✅ Returning full AI response
  
      } catch (jsonError) {
        console.error("Error parsing JSON response:", jsonError);
        return {
          error: "Failed to parse AI response",
          rawResponse: responseText
        };
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          window.location.href = "/Login"; // Redirect to login page
        }, 5000);
        return;
      }
      console.error("Error calling AI API:", err);
      return null;
    }
  };
  

  const updateMatchedSkills = async (jobSkills) => { 
    // Use Promise.all to resolve all async calculations
    const updatedResumes = await Promise.all(
        resumeText.map(async (resume) => {
            const { name, email, phoneNumber, matchedSkills, unmatchedSkills, matchedSkillsPercentage } = 
                await analyzeResumeWithJD(resume.resumeText, jobSkills); // Changed to jobSkills

            return { 
                ...resume,
                name, 
                email, 
                phoneNumber, 
                matchedSkills, 
                unmatchedSkills, 
                matchedSkillsPercentage 
            };
        })
    );

    console.log("Updated Resumes:", updatedResumes);
    setResumeText(updatedResumes);
    return updatedResumes; // Return the updated resumes instead of setting state
};

  const printRef = useRef();
const name = localStorage.getItem('firstName')
 const handleDownloadPdf = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element, { scale: 1.5 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const marginX = 10; // left/right padding in mm
    const marginY = 10; // top/bottom padding in mm

    const imgWidth = pageWidth - marginX * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = marginY;

    // First page
    pdf.addImage(imgData, "PNG", marginX, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - marginY * 2;

    // Extra pages
    while (heightLeft > 0) {
      position = heightLeft - imgHeight + marginY;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", marginX, position, imgWidth, imgHeight);
      heightLeft -= pageHeight - marginY * 2;
    }

  // ✅ Get binary blob instead of saving directly
  const pdfBlob = pdf.output("blob");

  // Save to local disk (optional)
  const url = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = url;
  const fileName = `resume_insights.pdf`;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
  };

  return (
    <ConsultantLayout>
  <div style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <h2 style={{ color: "#00a7ac" }}>AI Resume Insights</h2>
  
    </div>
    <hr style={{ width: "100%", borderTop: "1px solid #ccc" }} />
 {isLoading ? (
   <div style={{
     display: "flex",
     justifyContent: "center",
     alignItems: "center",
     height: "100vh", // Ensures it takes full screen height
     width: "100%",
   }}>
     <LoadingSpinner />
   </div>
 ) : (
   <>


  <h5 style={{ color: "#00a7ac",marginTop:12 }}>Upload Resumes</h5>
   <input  className="form-control "
  type="file" accept=".pdf, .docx" multiple onChange={handleFileUpload} style={{ marginBottom: "10px",height:'50px' }} />
  {loading ? <p>Processing Resumes... Please wait.</p> :
     <div style={{ width: "100%", gap: "20px", marginTop: "10px" }}>
      <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip id="tooltip">Select Job Title</Tooltip>}
>
  <div className="mt-3">
    <Controller
      name="JobRole"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          placeholder="Select Job Title"
          styles={{
            control: (provided) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              borderColor: errors.JobRole ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
              position: "absolute"
            })
          }}
        onChange={(selectedOption) => {
    field.onChange(selectedOption);
    const rawDescription = jobRoleDescriptions[selectedOption.value] || "";
    const plainTextDescription = stripHtmlTags(rawDescription); // remove HTML tags
    setJobResponsibilities(plainTextDescription);
    setValue("jobDescription", plainTextDescription); // Optional
    setSelectedJobPostId(selectedOption?.value ?? null);  
  }}
          className={`basic-form ${errors.JobRole ? 'is-invalid' : ''}`}
        />  
      )}
    />
    {errors.JobRole && (
      <div className="invalid-feedback d-block">{errors.JobRole.message}</div>
    )}
  </div>
</OverlayTrigger>

<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Candidate Type
</Tooltip>)}>
<select  {...register("CandidateType")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Candidate Type</option>
{
  candidateType.map((item,index)=>
  {
    return(

   <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
         <h5  className='mt-3' style={{color:"#00a7ac"}}>Job Description and Skillset</h5>


<textarea
  placeholder="Enter Job Description and Skillset Details"
  value={jobResponsibilities}
  className="form-control basic-form mt-3"
  onChange={(e) => {
    setJobResponsibilities(e.target.value);
    setValue("jobDescription", e.target.value); // Optional: sync with form
  }}
  style={{ width: "100%", height: "200px", padding: "10px" }}
/>
     </div>
     }
     <div className="mt-3">
  <label>
    <input
      type="checkbox"
      className="mr-3"
      
      checked={isGapAnalysisChecked}
  onChange={(e) => {
    const checked = e.target.checked;
    setIsGapAnalysisChecked(checked);
    if (checked) handleGapAnalysis();
  }}    />
     Career gap analysis
  </label>

  <label style={{ marginLeft: "50px" }}>
    <input
      type="checkbox"
      className="mr-3"
      checked={isNeedAdditionalPointsChecked}
  onChange={(e) => {
    const checked = e.target.checked;
    setIsNeedAdditionalPointsChecked(checked);
    if (checked) handleNecessaryPoints();
  }}    />
    Enhance resume to match this JD
  </label>

  <label style={{ marginLeft: "50px" }}>
  <input
    type="checkbox"
    className="mr-3"
    checked={isGenerateQuestionsChecked}
    onChange={(e) => setIsGenerateQuestionsChecked(e.target.checked)}
  />
  Generate screening questions
</label>

</div>

      <button
      onClick={() => {
      analyzeResumesAndCertifications();
      handleDetails();
      }}
      className="btn btn-primary mt-3"
        disabled={isComparing}
>
  {isComparing ? "Comparing..." : "Compare"}
    </button>
 
   <h4 style={{color:"#00a7ac",marginTop: "20px" }}>Comparison Results</h4>  
    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
   {/* {selectedCards.length > 0 && (
     <button className="btn btn-primary" onClick={handleSubmitTest}>
       Configure Test
     </button>
   )} */}
 </div>
     <div>
     
     {showDetails && resumeText.length > 0 ? (
        <div>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
  }}
>
  {/* Heading on the left */}
  <h4 style={{ color: "#00a7ac", margin: 0 }}>Extracted Details</h4>

  {/* Buttons on the right */}
  <div style={{ display: "flex", gap: "10px" }}>
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">save</Tooltip>}>
      <button
        className="btn btn-primary"
        style={{ height: 40, backgroundColor: "#00a7ac", border: "none" }}
        onClick={handleSaveCandidates}
      >
        Save Candidates
      </button>
    </OverlayTrigger>

    <button
      onClick={handleDownloadPdf}
      className="btn btn-primary"
      style={{ backgroundColor: "#00a7ac", border: "none" }}
    >
      Download as PDF
    </button>
  </div>
  </div>
       <div ref={printRef} style={{ padding: "20px", backgroundColor: "#fff" }}>
          {[...resumeText]
        .sort((a, b) => b.fitMatchScore - a.fitMatchScore)
          .map((resume, index) => {
            // const isSelected = selectedCards.find((card) => card.candidateID == resume.candidateID) !== undefined;
            return (  
             <div  style={{ marginTop: "20px",  width: "100%",  padding: "20px",  border: "1px solid #ccc",
    borderRadius: "10px",    display: "flex",    flexWrap: "wrap",   }}>
     
       <div style={{ width: "30%", paddingRight: "20px", borderRight: "1px solid #ddd" }}>
             
            <p style={{ fontSize: "18px" }}><strong>Name:</strong> {resume?.name}</p>
            <p style={{ fontSize: "18px" }}><strong>Email:</strong>{resume?.email}</p>
             <p style={{ fontSize: 18, display: 'flex', alignItems: 'center' }}><strong>Phone Number:</strong>{resume?.phoneNumber}<a
        href={`tel:${resume.phoneNumber}`}
        title="Click to Call"
        style={{ marginLeft: 10, color: "#00a7ac" }}
      >
        <i className="fas fa-phone"></i>
      </a></p>
            <p style={{ fontSize: "18px" }}><strong>File:</strong> {resume?.fileName}</p>
            <hr/>
              {/* <p style={{ fontSize: "18px" }}><strong> 🎯 Resume Skills:</strong>{resume?.skills?.length > 0 ? resume?.skills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p>  
            <hr/>
            <p style={{ fontSize: "18px" }}><strong> 🖥️ JD Skills:</strong>{extractedTextSkills.length > 0 ? extractedTextSkills?.sort((a, b) => a.localeCompare(b)).join(", ") : "Not Found"}</p>
            
            <hr/> */}
           {/* 🎓 Candidate Certifications */}
{resume?.certifications?.length ? (
  <>
    <p style={{ fontSize: "18px", marginBottom: 6 }}>
      <strong>🎓 Candidates Certifications:</strong>
    </p>
    <ul style={{ fontSize: 14, marginLeft: 20, marginBottom: 6 }}>
      {resume.certifications.map((cert, index) => (
        <li key={index}>{cert}</li>
      ))}
    </ul>
    <hr />
  </>
) : (
  <>
    <p style={{ fontSize: "18px" }}>
      <strong>🎓 Candidates Certifications:</strong> N/A
    </p>
    <hr />
  </>
)}

{/* 🧠 Skill Gaps */}
{resume?.skillGaps?.length ? (
  <>
    <p style={{ fontSize: 16, marginBottom: 6 }}>
      <strong style={{ color: "#00a7ac" }}>Skill Gaps:</strong>
    </p>

    <div style={{ fontSize: 14, marginBottom: 6 }}>
      {resume.skillGaps.map((item, idx) => (
        <div key={idx}>
          {item["JD Skill"]}: {item.Match}
        </div>
      ))}
    </div>

    <hr />

    <div style={{ fontSize: 12, marginBottom: 6 }}>
      <span style={{ marginRight: 15 }}>✅ Full Match</span>
      <span style={{ marginRight: 15 }}>🔶 Partial Match</span>
      <br />
      <span>❌ Skills Missing</span>
    </div>

    <hr />
  </>
) : (
  <>
    <p style={{ fontSize: 16 }}>
      <strong style={{ color: "#00a7ac" }}>Skill Gaps:</strong> N/A
    </p>
    <hr />
  </>
)}

   {isGapAnalysisChecked &&
            <p style={{ fontSize: "18px" }}>
 {resume?.timeGaps?.length > 0 && resume.timeGaps.some(gap => !gap.toLowerCase().includes("no significant")) ?  (
      <><strong style={{ color: "red", fontWeight: "bold" }}> ❌ Career Gaps:</strong><ul>
                      {resume.timeGaps.map((gap, index) => (
                        <li style={{ fontSize: "16px"}} key={index}>  {gap}</li>
                      ))}
                    </ul></>
  ) : (
  <>  <strong style={{ color: "red", fontWeight: "bold" }}> ❌ Career Gaps:</strong> 
    <ul>No significant gaps found.</ul></>
  )}
</p>
          }
           
      
     </div>
      <div style={{ width: "70%", paddingLeft: "20px" }}>
        <input
    type="checkbox"
    style={{ marginRight: "10px",float:'right' }}
    checked={selectedCandidates.includes(resume.email)}
    onChange={(e) => {
      if (e.target.checked) {
        setSelectedCandidates([...selectedCandidates, resume.email]);
      } else {
        setSelectedCandidates(
          selectedCandidates.filter((id) => id !== resume.email)
        );
      }
    }}
  />
 <div style={{ fontSize: "18px", color: "#00a7ac", marginTop: "10px" }}>
  <strong>Skill:</strong>{' '}
  <span style={{ fontSize: 26, color: "#000",marginRight:8 }}>
    {resume?.fitMatchScore ?? 0}%
  </span>{' '}

  <strong>Role:</strong>{' '}
  <span style={{ fontSize: 26, color: "#000",marginRight:8}}>
    {resume?.jobTitleMatchScore ?? 0}%
  </span>{' '}
  <strong>Experience:</strong>{' '}
  <span style={{ fontSize: 26, color: "#000" }}>
    {resume?.experienceMatchScore ?? 0}% Match
  </span>
</div>

<hr/>
<p style={{ fontSize: 16 }}>
  <strong style={{ color: "#00a7ac" }}>High-Level Fit Summary:</strong>{" "}
   <p style={{fontSize:18, fontWeight: "bold", color:"#00a7ac"}}></p> <span style={{ fontSize: "18px" }}>{resume?.overallSummary}</span>
   <br/>
  {resume?.overallFitTable?.map((item, idx) => (
    <span style={{ fontSize: "18px" }} key={idx}>
      {item.Category}: {item.MatchLevel}-{item.Notes}
      <br/>
      {/* {idx < resume.overallFitTable.length - 1 && " | "} */}
    </span>
  ))}
   <hr/>
</p>
         
            {/* <p style={{fontSize:18, fontWeight: "bold", color:"#00a7ac"}}><strong> 🧩 Matched Skills:</strong>{resume?.matchedSkills?.length > 0 ? resume.matchedSkills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p> 
          <hr/>
            <p style={{fontSize:18, fontWeight: "bold", color:"red"}}><strong> ⚠️ UnMatched Skills:</strong>{resume?.unmatchedSkills?.length > 0 ? resume.unmatchedSkills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p> 
          <hr/> */}
            {/* <p style={{ fontSize: "18px" }}><strong> 📜 Matched Certifications with Job Responsibilities:</strong>{ <ul>
              {resume?.matchedCertificationswithJobResponsibilities?.map((cert, index) => (
                <li key={index}> {cert}</li>
              ))}
            </ul>}</p> */}
          
<>
  <p style={{ fontSize: 16 }}>
    <strong style={{ color: "#00a7ac" }}>
      📌 JD Skills Matched in Recent Projects:
    </strong>
  </p>

  {resume?.matchedSkillsInRecentProjects?.length > 0 ? (
    <ul>
      {resume.matchedSkillsInRecentProjects.map((item, idx) => (
       <li key={idx} style={{ fontSize: "18px" }}>
  ✅ <strong>{item["JD Skill"]}</strong> — {item["Found in Project"]}
</li>
      ))}
    </ul>
  ) : (
    <p style={{ fontSize: 16, color: "gray", marginLeft: 10 }}>
      No matched JD skills found in recent projects.
    </p>
  )}
  <hr />
</>


            <p style={{ fontSize: "18px"}}><strong style={{color:"#00a7ac",fontWeight: "bold",}}> 💡 Improvement Insights:</strong>{ <ul>
              {resume?.necessaryImprovements?.map((reason, index) => (
                <li key={index}>{reason}</li>
              ))}
            </ul>}</p>
  
  {isNeedAdditionalPointsChecked &&<p style={{ fontSize: "18px" }}>
  <hr/>
 {resume?.enhancements?.length > 0  ? (
     <><strong style={{ color: "#00a7ac", fontWeight: "bold" }}> 🛠️ Enhance Resume to Match This JD:</strong><ul>
                      {resume?.enhancements.map((point, index) => (
                        <li key={index}>  {point}</li>
                      ))}
                    </ul></>
  ) : (
    <span> No enhancement points detected.</span>
  )}
</p>
          }

      

</div>
            </div>
            )
      })}
      </div></div>) : (
              <p>No comparison done yet.</p>
            )
         }
   </div>
  {screeningQuestions.screening_questions?.length > 0 && (
  <div style={{ marginTop: "30px", fontSize: 18 }}>
    <h5 style={{ color: "#00a7ac" }}>🧪 Screening Questions</h5>
    <ul>
      {screeningQuestions.screening_questions.map((q, idx) => (
        <li key={idx}>
          <strong>Q:</strong> {q.question}<br />
          <strong>Expected Answer:</strong> {q.answer}
          <hr />
        </li>
      ))}
    </ul>
  </div>
)}

{screeningQuestions.coding_questions?.length > 0 && (
  <div style={{ marginTop: "30px", fontSize: 18 }}>
    <h5 style={{ color: "#00a7ac" }}>💻 Coding Questions</h5>
    <ul>
      {screeningQuestions.coding_questions.map((q, idx) => (
        <li key={idx}>
          <strong>Q:</strong> {q.question}<br />
          <strong>Solution:</strong> <pre>{q.answer}</pre>
          <hr />
        </li>
      ))}
    </ul>
  </div>
)}


   </>)}
    </div>
  </ConsultantLayout>
  )}



export default ResumeParserwithAi;